import { http } from '@/app/lib/http/client'

export interface ProductExportPayload {
  limit?: number
  search?: string
  category_ids?: number[]
  department_ids?: number[]
  product_type_ids?: number[]
  created_from?: string
  created_to?: string
  updated_from?: string
  updated_to?: string
  stock_mode: 'all_sucursals' | 'selected_sucursal'
  sucursal_id?: number
}

export interface ProductExportResponse {
  id: number
  status: 'pending' | 'processing' | 'completed' | 'failed'
  file_url?: string
  error_message?: string
}

export const reportService = {
  /**
   * Crea una nueva solicitud de exportación de productos.
   * Retorna el registro de exportación creado (con estado pending o processing).
   */
  async createProductExport(payload: ProductExportPayload): Promise<ProductExportResponse> {
    const response = await http.post('/reports/product-exports', payload)
    // Extraemos la data. La API en Laravel usualmente la envuelve en un "data"
    return response.data?.data || response.data
  },

  /**
   * Consulta el estado de una exportación en proceso.
   */
  async getProductExportStatus(id: number): Promise<ProductExportResponse> {
    const response = await http.get(`/reports/product-exports/${id}`)
    return response.data?.data || response.data
  },

  /**
   * Descarga el archivo de la exportación (XLSX).
   * Devuelve un Blob que el navegador puede procesar como archivo.
   */
  async downloadProductExport(id: number): Promise<Blob> {
    const response = await http.get(`/reports/product-exports/${id}/download`, {
      responseType: 'blob'
    })
    return response.data
  }
}
